import { reportScopedError } from 'shared-utils/error'

export default defineNuxtPlugin(() => {
  if (!import.meta.client) {
    return
  }

  // A plugin must never take the whole app down: Nuxt would replace the rendered page with error.vue.
  try {
    const scroll = useSamePageScroll()

    scroll.start()
  } catch (err) {
    const error = err as Error

    reportScopedError('plugins::same-page-scroll', 'Initialization failed', error)
  }
})
